import { useEffect, useState } from "react";

/** How often the now-line, past shading and "Next up · in N min" refresh. */
export const NOW_TICK_MS = 60_000;

/** The current time, re-read every `intervalMs`. */
export function useNow(intervalMs = NOW_TICK_MS): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
